import { type FC } from "react";
import Icon from "@mdi/react";
import { mdiOpenInNew } from "@mdi/js";
import { Button, Input, TextField } from "@heroui/react";
import HelpPhoneField from "./HelpPhoneField";

export interface HelpCustomerDraft {
  clientName: string;
  clientPhone: string;
  vehicle: {
    makeModel: string;
    regNumber: string;
    vin: string;
    year: string;
  };
}

interface HelpCustomerEditorProps {
  customer: HelpCustomerDraft;
  onChange: (customer: HelpCustomerDraft) => void;
  onOpenClient: () => void;
}

const HelpCustomerEditor: FC<HelpCustomerEditorProps> = ({
  customer,
  onChange,
  onOpenClient,
}) => {
  const setCustomer = (patch: Partial<HelpCustomerDraft>) => {
    onChange({ ...customer, ...patch });
  };

  const setVehicle = (patch: Partial<HelpCustomerDraft["vehicle"]>) => {
    onChange({
      ...customer,
      vehicle: { ...customer.vehicle, ...patch },
    });
  };

  return (
    <div className="help-edit" data-testid="help-customer-editor">
      <div className="help-customer-edit__head">
        <span className="help-view-section__title">Заказчик</span>
        <Button variant="ghost" size="sm" onPress={onOpenClient}>
          <Icon path={mdiOpenInNew} size={0.75} />
          Карточка клиента
        </Button>
      </div>
      <div className="help-edit-grid">
        <label className="help-form-field">
          Имя
          <TextField fullWidth>
            <Input
              value={customer.clientName}
              onChange={(e) => setCustomer({ clientName: e.target.value })}
              placeholder="ФИО клиента"
            />
          </TextField>
        </label>
        <label className="help-form-field">
          Телефон
          <HelpPhoneField
            value={customer.clientPhone}
            onChange={(clientPhone) => setCustomer({ clientPhone })}
          />
        </label>
        <label className="help-form-field help-form-field--wide">
          Автомобиль
          <TextField fullWidth>
            <Input
              value={customer.vehicle.makeModel}
              onChange={(e) => setVehicle({ makeModel: e.target.value })}
              placeholder="Марка и модель"
            />
          </TextField>
        </label>
        <label className="help-form-field">
          Госномер
          <TextField fullWidth>
            <Input
              value={customer.vehicle.regNumber}
              onChange={(e) => setVehicle({ regNumber: e.target.value })}
              placeholder="A000AA777"
            />
          </TextField>
        </label>
        <label className="help-form-field">
          VIN
          <TextField fullWidth>
            <Input
              value={customer.vehicle.vin}
              onChange={(e) => setVehicle({ vin: e.target.value })}
              placeholder="VIN"
            />
          </TextField>
        </label>
        <label className="help-form-field">
          Год выпуска
          <TextField fullWidth>
            <Input
              value={customer.vehicle.year}
              onChange={(e) => setVehicle({ year: e.target.value })}
              placeholder="2020"
            />
          </TextField>
        </label>
      </div>
    </div>
  );
};

export default HelpCustomerEditor;
